import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { Box, Button, Link, Typography } from "@mui/material";
import React, { SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../store/store";
import { ETheme } from "../enums/user/ETheme";
import { ILayout } from "../interfaces/shared/ILayout";
import { darkTheme, lightTheme } from "../mui/theme";
import SidebarItems from "./SidebarItems";

interface IProps {
  routes: ILayout[] | undefined;
  isCollapsed: boolean;
  setIsCollapsed: React.Dispatch<SetStateAction<boolean>>;
}

const Sidebar = ({ routes, isCollapsed, setIsCollapsed }: IProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userData } = useSelector((state: RootState) => state.auth);
  const company = useSelector((state: RootState) => state?.companySettings);

  const changeTheme = (selectedTheme: ETheme) => {
    if (!!userData?.id) {
      const formData = new FormData();
      formData.append("body", JSON.stringify({ theme: selectedTheme }));
    }
  };

  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor:
          userData?.theme === ETheme.LIGHT
            ? lightTheme.palette.background.paper
            : darkTheme.palette.background.paper,
        borderRadius: "10px",
        height: "95vh",
        transition: "all 0.4s ease-in-out",
        width: isCollapsed ? "60px" : "250px",
        overflow: "hidden",
        position: "sticky",
        paddingRight: "2px",
        top: 0,
        left: 0,
        display: "flex",
        flexDirection: "column",
        zIndex: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "10px",
          cursor: "pointer",
        }}
      >
        <Box
          onClick={() => {
            const collapsed = isCollapsed;
            setIsCollapsed(!collapsed);
            localStorage.setItem("menuCollapsed", String(!collapsed));
          }}
        >
          {isCollapsed ? (
            <MenuIcon fontSize="large" />
          ) : (
            <MenuOpenIcon fontSize="large" />
          )}
        </Box>

        {!isCollapsed && (
          <img
            src={
              company?.thumbnail
                ? userData?.theme === ETheme.DARK
                  ? company?.invertedThumbnail
                  : company?.thumbnail
                : userData?.theme === "light"
                  ? "/logo-light.png"
                  : "/logo-dark.svg"
            }
            alt="Logo"
            width="75%"
            className={"logo"}
            style={{
              transition: "all 0.4s ease-in-out",
              paddingLeft: "1rem",
            }}
            onClick={() => navigate(`/user/dashboard`)}
          />
        )}
      </Box>

      <SidebarItems isCollapsed={isCollapsed} routes={routes} />

      {!isCollapsed && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            margin: "auto 0 1rem",
          }}
        >
          <Typography variant={"body2"}>
            {new Date().getFullYear()} ©{" "}
            <a href={"https://onebms.net/"} target={"_blank"} rel="noreferrer">
              onebms.net
            </a>
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default Sidebar;
